import {
  resolveRazaPrintPaperSize,
  RAZA_PRINT_PAPER_SIZE_OPTIONS,
  type RazaPrintPaperSize,
} from "@/utils/raza-print-paper-size";

export { RAZA_PRINT_PAPER_SIZE_OPTIONS };

export type TenantSettingsFormState = {
  tenantId: string;
  razaPrintPaperSize: RazaPrintPaperSize;
  googleCalendarId: string;
};

export function toTenantSettingsFormState(
  data: Partial<{
    tenantId: string;
    razaPrintPaperSize: string | null;
    googleCalendarId: string | null;
  }>
): TenantSettingsFormState {
  return {
    tenantId: data.tenantId ?? "",
    razaPrintPaperSize: resolveRazaPrintPaperSize(data.razaPrintPaperSize),
    googleCalendarId: data.googleCalendarId ?? "",
  };
}

export function toTenantSettingsPatch(state: TenantSettingsFormState) {
  return {
    razaPrintPaperSize: resolveRazaPrintPaperSize(state.razaPrintPaperSize),
    googleCalendarId: state.googleCalendarId.trim() === "" ? null : state.googleCalendarId.trim(),
  };
}
